import type { NodeId, NodeRegistry } from '../types';

export function getNodeById(id: NodeId, registry: NodeRegistry) {
  return registry[id];
}
